import { useCallback } from 'react';
import { log } from 'log';
import { prop } from 'ramda';
import { useGetPlayerTags } from 'server';
import { useNavigate } from 'js/hooks/navigate';
import { useAppSelector } from 'js/store/hooks';
import { useTranslations } from 'js/hooks/i18n';
import { storageService } from 'js/services/storage.service';

const VERIFIED_TAG_NAME = 'uam/verification/conversion_verified';
const KYC_1_TAG_NAME = 'risk/kyc_x1';
const KYC_2_TAG_NAME = 'risk/kyc_x2';
const UPLOAD_REQUIREMENT_TAG_NAME = 'risk/doc/upload_requirement';
const tagList = [VERIFIED_TAG_NAME, KYC_1_TAG_NAME, KYC_2_TAG_NAME, UPLOAD_REQUIREMENT_TAG_NAME];

export const useRedirectAfterLogin = () => {
    const navigate = useNavigate();
    const getPlayerTags = useGetPlayerTags();
    const dynamicTags = useAppSelector(prop('dynamicTags'));
    const { DTAG_PROFILE_PAGE, DTAG_DEPOSIT_PAGE } = dynamicTags;
    const translate = useTranslations('playtech.mobile.system.verificationStatus.popup.');

    return useCallback(({ afterRegisterLogin = false }) => {
        if (!afterRegisterLogin) {
            return;
        }

        getPlayerTags({ tagName: tagList.join(',') })
            .then(({ tags = [] }) => {
                const isUserVerified = Boolean(tags.find(tag => tag.name.toLowerCase() === VERIFIED_TAG_NAME));
                const isUserKycMadeOnce = Boolean(tags.find(tag => tag.name.toLowerCase() === KYC_1_TAG_NAME));
                const isUserKycMadeTwice = Boolean(tags.find(tag => tag.name.toLowerCase() === KYC_2_TAG_NAME));
                const uploadRequirements = tags.find(tag => tag.name.toLowerCase() === UPLOAD_REQUIREMENT_TAG_NAME);

                if (isUserVerified) {
                    navigate(DTAG_DEPOSIT_PAGE);

                    window.Playtech.API.popup.showPopup({
                        title: translate('title'),
                        content: translate('text'),
                        btnTitle: translate('declineBtnText')
                    });

                    return;
                }

                if (isUserKycMadeOnce || isUserKycMadeTwice || ['pending', 'optional', 'mandatory'].includes(uploadRequirements.value)) {
                    navigate(DTAG_PROFILE_PAGE);

                    return;
                }

                const afterRegisterRedirectPath = storageService.session.getItem('afterRegisterRedirectPath') || '/';

                navigate(afterRegisterRedirectPath);
            })
            .catch(error => log('error', error));
    }, [navigate, translate, DTAG_PROFILE_PAGE, DTAG_DEPOSIT_PAGE, getPlayerTags]);
};
